import React from "react";

import KoraxSignEditor
  from "../KoraxSignEditor";

import KoraxSignTimeline
  from "../../components/KoraxSignTimeline";

import {
  AuthContext
} from "../../context/Auth/AuthContext";


// KORAX SIGN PENSOU RELEASE V0.8C

const KoraxSignDocumentWorkspace =
  props => {

    const {
      user
    } =
      React.useContext(
        AuthContext
      );


    // KORAX SIGN PENSOU FULL ACCESS V0.8D
    const canManageSign =
      Boolean(
        user?.super
      ) ||
      Number(
        user?.companyId
      ) === 72;


    const documentId =
      Number(
        props &&
        props.match &&
        props.match.params &&
        props.match.params.id
      );


    return (

      <div
        style={{
          width:
            "100%"
        }}
      >

        {canManageSign ? (

          <KoraxSignEditor
            {...props}
          />

        ) : (

          <div
            style={{
              margin:
                "22px 22px 0",
              padding:
                16,
              border:
                "1px solid #B2CCFF",
              background:
                "#F5F8FF",
              borderRadius:
                12,
              color:
                "#344054",
              fontSize:
                13,
              lineHeight:
                1.55
            }}
          >
            <strong>
              Visualização compartilhada
            </strong>

            <div
              style={{
                marginTop:
                  5
              }}
            >
              Você pode acompanhar o histórico deste documento.
              Configuração e envio são ações exclusivas dos administradores.
            </div>
          </div>

        )}


        {Number.isInteger(
          documentId
        ) &&
        documentId > 0 && (

          <KoraxSignTimeline
            documentId={
              documentId
            }
          />

        )}

      </div>
    );
  };


export default
  KoraxSignDocumentWorkspace;
